import React from 'react';
import { PageBanner } from '../components/Layout';
import Seo from '../components/Seo';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { FAQS, PSYPACT_URL, SITE_URL } from '../mock';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  url: `${SITE_URL}/faqs`,
  mainEntity: FAQS.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a.replace(/\n+/g, ' ').trim() },
  })),
};

const FAQs = () => {
  return (
    <div>
      <Seo
        title="FAQs — Insurance, Fees, Payments & PSYPACT"
        description="Answers to common questions about therapy at The Mood & Sleep Clinic: what to expect, accepted insurance (Medica, UHC, BCBS, Aetna, Health Partners, Cigna), fees, payments, and PSYPACT states."
        path="/faqs"
        schema={faqSchema}
      />
      <PageBanner title="FAQs" subtitle="Common questions, answered with care" />
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-4">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-white border border-border rounded-xl px-5 shadow-sm data-[state=open]:shadow-md transition-shadow"
              >
                <AccordionTrigger className="text-left font-heading text-navy text-base sm:text-lg hover:no-underline py-5">
                  <span className="flex gap-3">
                    <span className="text-[#3d6a9c] font-semibold">{i + 1}.</span>
                    <span>{f.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed text-[15px] pb-5">
                  <div className="whitespace-pre-line">{f.a}</div>
                  {i === 3 && (
                    <a href={PSYPACT_URL} target="_blank" rel="noopener noreferrer" className="inline-block mt-3 text-[#3d6a9c] font-medium hover:text-navy underline">
                      View the PSYPACT map →
                    </a>
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
};

export default FAQs;
